<template>
    <v-card>
        <v-card-title>
            <span class="headline">Connect WPS</span>
        </v-card-title>
        <v-card-text>
            Description WPS technology
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="start()">Start WPS</v-btn>
            <v-dialog
                v-model="dialog"
                persistent
                width="300"
                >
                <v-card dark>
                    <v-card-title>
                        Status: {{status_message}}
                    </v-card-title>
                    <v-card-text>
                        {{message}}
                        <v-progress-linear 
                        :indeterminate="!completed"
                        value="100"
                        color="white"
                        class="mb-0"
                        ></v-progress-linear>
                        <v-layout align-center v-if="completed">
                            <v-spacer></v-spacer>
                            <v-btn icon ripple color="white" @click="dialog = false">
                                <v-icon v-if="completed == 'success'" color="green">check_circle</v-icon>
                                <v-icon v-else color="red">error</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card-actions>
    </v-card>
</template>
<script>
import {
  Utils,
} from "@/common/api.service";
import { mapGetters } from "vuex";
import { NETWORK_WIFI_WPS_START, NETWORK_WIFI_WPS_STATUS } from "../store/actions.type";

export default {
  name: "NetworkSettingsWifiConnectWps",
  data: () => ({
      dialog: false,
      refresher: null,
      counter: 0,
      //message: null,
      //status_message: null
  }),
  mounted() {
      
  },  
  methods: {
    async start() {
        this.dialog = true
        this.counter = 0;
        //this.message = "You have two minutes to press WPS button on AP"
        //this.status_message = "Started..."
        await this.$store.dispatch(NETWORK_WIFI_WPS_START);

        this.refresher = setInterval(() => {
            console.log("Refresh status")
            this.counter++
            if (this.completed) {
                
                clearInterval(this.refresher)
            }else
                this.$store.dispatch(NETWORK_WIFI_WPS_STATUS);
        }, 1000)
        
    }
  },
  computed: {
    ...mapGetters(["wifi_wps_status"]),
    completed: function() {
        if (this.counter>60)
        {
            //this.status_message = "Failed"
            //this.message = "Elapsed time"
            return "failed"
        }
        if (!this.wifi_wps_status.log)
            return false
            
        for (let i=0; i< this.wifi_wps_status.log.length; i++) {
            let match = this.wifi_wps_status.log[i].match(/CTRL-EVENT[^ ]*/)
            if (match) {
                //this.status_message = this.$t("wpa.log.ctrl." + match)
            }
            if (this.wifi_wps_status.log[i].match(/CTRL-EVENT-CONNECTED/)) {
                //this.message = 'You are connected to ' + this.wifi_wps_status.ssid
                return "success"
            }
                
        }
        return false;
    },
    message: function() {
        if (!this.completed) {
            return "You have two minutes to press WPS button on AP"
        }
        if (this.completed == 'failed') {
            return "Elapsed time"
        }
        if (this.completed == 'succes') {
            return 'You are connected to ' + this.wifi_wps_status.ssid
        }
        return "Unknown status"
    },
    status_message: function() {
        if (this.completed == 'failed') {
            return "Failed"
        }
        if (this.completed == 'succes') {
            return 'You are connected to ' + this.wifi_wps_status.ssid
        }
        if (!this.wifi_wps_status.log || !this.wifi_wps_status.log.length) {
            return "Started..."
        }
        let last = this.wifi_wps_status.log.length-1
        let match = this.wifi_wps_status.log[last].match(/CTRL-EVENT[^ ]*/)
        if (match) {
            return this.$t("wpa.log.ctrl." + match)
        }
        return "Unknown status"
        
    }
  },

}
</script>

